<template>
    <div class="container">
        <md-dialog :md-active.sync="showDialogEditNiif" :md-click-outside-to-close="false">
            <md-dialog-title class="dialog-header">
                <span class="header-title">{{ labels.title }}</span>
            </md-dialog-title>
            <md-dialog-content class="dialog-content">
                <div class="form-container">
                    <!-- Información principal -->
                    <div class="form-group">
                        <div class="form-field">
                            <label class="field-label">{{ labels.niif }}</label>
                            <div class="field-value">{{ Item.niif }}</div>
                        </div>
                        <div class="form-field" v-if="!showReclasifica">
                            <label class="field-label">{{ labels.description }}</label>
                            <md-field class="custom-field">
                                <md-input v-model="Item.descripcion" :placeholder="labels.description" />
                            </md-field>
                        </div>
                        <div class="form-field" v-if="showReclasifica">
                            <label class="field-label">{{ labels.description }}</label>
                            <div class="field-value">{{ Item.descripcion }}</div>
                        </div>
                    </div>

                    <!-- Campos de reclasificación -->
                    <div class="form-field-full" v-if="showReclasifica">
                        <label class="field-label">{{ labels.reclasificar }}</label>
                        <md-field class="custom-field">
                            <md-input type="text" v-model="Item.niif_nuevo" :placeholder="labels.reclasificar" />
                        </md-field>
                    </div>

                    <!-- Niveles -->
                    <div class="form-group" v-if="!showReclasifica">
                        <div class="form-field">
                            <label class="field-label">{{ labels.levelFirst }}</label>
                            <md-field class="custom-field">
                                <select v-model="Item.primer_nivel" @change="onChange($event)" class="modern-select">
                                    <option value="">{{ labels.select }}</option>
                                    <option v-for="firstLev in listFirstLevel" :key="firstLev.id" :value="firstLev.primer_nivel">
                                        {{ firstLev.descripcion }}
                                    </option>
                                </select>
                            </md-field>
                        </div>
                        <div class="form-field">
                            <label class="field-label">{{ labels.levelSecond }}</label>
                            <md-field class="custom-field">
                                <select v-model="Item.segundo_nivel" class="modern-select">
                                    <option value="">{{ labels.select }}</option>
                                    <option v-for="secondLev in listSecondLevelFirst" :key="secondLev.id" :value="secondLev.segundo_nivel">
                                        {{ secondLev.descripcion }}
                                    </option>
                                </select>
                            </md-field>
                        </div>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="dialog-actions">
                <div class="actions-left">
                    <md-button class="md-raised delete-btn" @click="confirmDelete">
                        <b-icon icon="trash" class="me-2"></b-icon>
                        {{ labels.delete }}
                    </md-button>
                </div>
                <div class="actions-right">
                    <md-button v-if="!showReclasifica" class="md-raised secondary-btn" @click="reclasificarNiif">
                        {{ labels.breclasificar }}
                    </md-button>
                    <md-button class="md-raised cancel-btn" @click="closeDialog">
                        {{ labels.close }}
                    </md-button>
                    <md-button class="md-raised md-primary save-btn" @click="confirmSave">
                        {{ labels.save }}
                    </md-button>
                </div>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import PlanConsolidacion from "../../services/PlanConsolidacion"

export default {
    name:"EditaNiif",
    props:['Item','showDialogEditNiif','listFirstLevel','listSecondLevelFirst','listNiif'],

    data: () => ({
        descripcion: "",
        idNiif: "",
        showReclasifica: false,
        originalItem: null,
        isSaving: false
    }),

    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Modificación NIIF",
                    niif : "NIIF",
                    select : "Seleccione...",
                    levelFirst : "Primer Nivel",
                    levelSecond : "Segundo Nivel",
                    save : "Guardar",
                    breclasificar : "Reclasificar",
                    reclasificar : "NIIF Nuevo",
                    close : "Cerrar",
                    description : "Descripción",
                    delete : "Eliminar"
                }
            }else{
                return {
                    title: "NIIF Update",
                    niif : "NIIF",
                    select : "Select...",
                    levelFirst : "First Level",
                    levelSecond : "Second Level",
                    save : "Save",
                    breclasificar : "Reclassify",
                    reclasificar : "New NIIF",
                    close : "Close",
                    description : "Description",
                    delete : "Delete"
                }
            }
        },
        hasUnsavedChanges() {
            if (!this.originalItem || this.isSaving) return false;
            return JSON.stringify(this.Item) !== JSON.stringify(this.originalItem);
        }
    },

    watch: {
        Item: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.originalItem = { ...newVal };
                }
            }
        },
        showDialogEditNiif: {
            handler(newVal) {
                if (newVal && this.Item) {
                    this.originalItem = { ...this.Item };
                    this.isSaving = false;
                    this.showReclasifica = false;
                }
            },
            immediate: true
        }
    },

    methods: {
        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?";

                if (window.confirm(message)) {
                    this.restoreOriginalValues();
                    this.clicked();
                }
            } else {
                this.clicked();
            }
        },

        confirmSave() {
            const message = this.$store.state._language == "es-ES"
                ? "¿Está seguro que desea guardar los cambios?"
                : "Are you sure you want to save the changes?";

            if (window.confirm(message)) {
                this.editarNiif();
            }
        },

        clicked(){
            this.showReclasifica = false;
            this.$emit('clicked', false);
        },

        reload(){
            this.$emit('reload');
        },

        restoreOriginalValues() {
            if (this.originalItem) {
                Object.assign(this.Item, this.originalItem);
            }
        },

        confirmDelete() {
            if(confirm(this.$store.state._language == "es-ES" 
                ? "¿Está seguro de que desea eliminar este registro NIIF?" 
                : "Are you sure you want to delete this NIIF record?")) {
                this.$emit('delete-item', this.Item.id);
                this.clicked();
            }
        },
        
        editarNiif(){
            if(this.showReclasifica) {
                if(this.Item.niif_nuevo == "") {
                    this.$toast.error("Nuevo NIIF no puede estar vacío");
                    return;
                }
                const nuevoNiif = this.listNiif.find((r_niif) =>  
                    r_niif.niif == this.Item.niif_nuevo
                );
                if(nuevoNiif) {
                    this.$toast.error("NIIF ya existe.("+nuevoNiif.nameNiif+")");
                    this.Item.niif_nuevo = this.Item.niif;
                    return;
                }
                
                this.isSaving = true;
                let form = {
                    'codReporte'    : this.Item.codReporte,
                    'vigencia'      : this.Item.vigencia,
                    'niif'          : this.Item.niif,
                    'niif_nuevo'    : this.Item.niif_nuevo,
                };
                
                PlanConsolidacion.reclasificaNiif(form)
                .then((res) => {
                    this.$toast.success(res.data.message);
                    this.clicked();
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.isSaving = false;
                    this.reload();
                });
                return;
            }
            
            if(this.Item.descripcion == ""){
                this.$toast.error("Diligenciar el campo Descripción");
            } else {
                this.isSaving = true;
                let form = {
                    'idNiif'        : this.Item.id,
                    'descripcion'   : this.Item.descripcion,
                    'primer_nivel'  : this.Item.primer_nivel,
                    'segundo_nivel' : this.Item.segundo_nivel
                };

                PlanConsolidacion.updatePlanconsolidacion(form)
                .then((res) => {
                    this.$toast.success(res.data.message);
                    this.clicked();
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.isSaving = false;
                    this.reload();
                });
            }                
        },

        reclasificarNiif(){
            this.showReclasifica = true;
        },

        onChange(event){
            let value = event.target.value;
            this.Item.segundo_nivel = "";
            this.$emit('leaSegundoNivel', value);
        },
    }
}
</script>

<style scoped>
/* Header del diálogo */
.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    padding: 20px 24px;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* Grupos de formulario */
.form-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.form-field-full {
    width: 100%;
}

/* Labels y campos */
.field-label {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.field-value {
    padding: 12px 0;
    font-weight: 600;
    color: #34495e;
    font-size: 15px;
    border-bottom: 1px solid #ecf0f1;
}

/* Campos de formulario */
.custom-field {
    margin: 0;
}

.modern-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    transition: border-color 0.2s ease;
}

.modern-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

/* Acciones del diálogo */
.dialog-actions {
    padding: 20px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    background: #f8f9fa;
}

.actions-left {
    display: flex;
}

.actions-right {
    display: flex;
    gap: 12px;
}

.delete-btn {
    background: #e74c3c !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 20px;
    min-width: 120px;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.secondary-btn {
    background: #f39c12 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 20px;
    min-width: 120px;
}

.delete-btn:hover {
    background: #c0392b !important;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover {
    background: #2980b9 !important;
}

.secondary-btn:hover {
    background: #e67e22 !important;
}

/* Responsive */
@media (max-width: 768px) {
    .form-group {
        grid-template-columns: 1fr;
        gap: 16px;
    }
    
    .form-container {
        padding: 16px;
    }
    
    .dialog-actions {
        padding: 16px;
        flex-direction: column;
        gap: 12px;
    }
    
    .actions-left, .actions-right {
        width: 100%;
        justify-content: center;
    }
}
</style>